import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { MultiStep, MultiStepControl } from '@frontend/design-system';

export type RegisterTerminalStepperProps = {
  steps: {
    id: string;
    title: string;
    component: React.ReactNode;
    parentId?: string;
  }[];
  multiStepControl: MultiStepControl;
};

const styles = {
  overrides: css`
    padding: ${theme.spacing(2)};
    padding-right: ${theme.spacing(3)};

    .stepper__label-text {
      overflow: visible;
      text-overflow: unset;
      white-space: normal;
    }

    .wv-modal-flex-content {
      padding-left: 0;
      padding-right: 0;
    }

    .multi-step__header-wrapper {
      padding-top: ${theme.spacing(1)};
    }
    .multi-step__footer-wrapper {
      display: none;
    }
    .register-terminal__footer {
      padding-left: 0;
      padding-right: 0;
      margin-top: auto;
    }
    .step__body {
      display: flex;
      flex-direction: column;
    }
    .multi-step__body {
      padding-left: ${theme.spacing(3)};
      padding-bottom: ${theme.spacing(1)};
    }
  `,
  stepper: css`
    /* .stepper__item {
      margin-top: ${theme.spacing(2)};
    }
    .stepper__progress--bg {
      height: 90%;
    } */
  `,
};
export const RegisterTerminalStepper = ({ steps, multiStepControl }: RegisterTerminalStepperProps) => {
  return (
    <MultiStep.Root {...multiStepControl} css={styles.overrides}>
      {steps.map((step) => (
        <MultiStep.Step
          components={{ Footer: () => null }}
          label={step.title}
          id={step.id}
          key={step.id}
          parentId={step.parentId}
        >
          {step.component}
        </MultiStep.Step>
      ))}
    </MultiStep.Root>
  );
};
